import { Refresh } from "@mui/icons-material";
import { Box, Button, CircularProgress, Tab, Tabs, Typography } from "@mui/material";
import React, { useState } from "react";
import { t } from "ttag";
import ServiceNavigationBar from "../../widgets/Menu/ServiceNavigationBar";
import DeviceInformationCard from "../DeviceManagment/DeviceInformationCard";
import ConnectionsTable from "./ConnectionsTable";
import { AuditTab, auditTabPath, resolveAuditTab } from "./deviceAuditsTabs";
import useStyles from "./EdgeAudits.style";
import { ITelemetryRecoveryAudit } from "./edgeAuditsUtils";
import TelemetryRecoveryTable from "./TelemetryRecoveryTable";
import { useNgDevice } from "./useNgDevice";

/**
 * Hidden page, like /devices/:deviceId/sync: append /audit to a device URL to get the
 * EDGE audit tabs (CM-730 connections, CM-731 telemetry recovery). The ticketed paths
 * /connections and /telemetry-recovery open the same page on that tab.
 */
const DeviceAudits = (props: any) => {
  const classes = useStyles();
  const deviceParam = props.match?.params?.deviceId || "";
  const {
    device,
    setDevice,
    deviceId,
    loading: loadingDevice,
    error: deviceError,
    refreshDeviceStatus
  } = useNgDevice(deviceParam);
  const [tab, setTab] = useState<AuditTab>(() => resolveAuditTab(props.match?.path, props.location?.search));
  const [refreshKey, setRefreshKey] = useState(0);

  const changeTab = (next: AuditTab) => {
    setTab(next);
    props.history.replace(auditTabPath(deviceParam, next));
  };

  const openAudit = (audit: ITelemetryRecoveryAudit) => {
    // keeps whatever id-or-serial form the URL used; the API calls use the resolved id
    props.history.push(`/devices/${deviceParam}/telemetry-recovery/${audit.id}`);
  };

  // reloads the open tab on its current page and the device's connection status
  const refresh = () => {
    setRefreshKey((key) => key + 1);
    refreshDeviceStatus();
  };

  return (
    <ServiceNavigationBar title={t`NG device audits`} {...props}>
      <Box className={classes.page}>
        {loadingDevice && (
          <Box display="flex" justifyContent="center" mt={6}>
            <CircularProgress />
          </Box>
        )}

        {!loadingDevice && deviceError && <Typography className={classes.empty}>{deviceError}</Typography>}

        {!loadingDevice && !deviceError && device && (
          <>
            <Box className={classes.toolbar}>
              <span className={classes.toolbarSpacer} />
              <Button variant="outlined" className={classes.actionButton} startIcon={<Refresh />} onClick={refresh}>
                {t`Refresh`}
              </Button>
            </Box>

            <DeviceInformationCard
              device={device}
              setDevice={setDevice}
              deviceId={deviceId}
              history={props.history}
              companion="terminal"
              layout="row"
              compact
              onRetryConnection={refreshDeviceStatus}
            />

            <Tabs value={tab} onChange={(_, value) => changeTab(value)} className={classes.tabsBar}>
              <Tab value="connections" label={t`Connections`} />
              <Tab value="telemetry-recovery" label={t`Telemetry recovery`} />
            </Tabs>

            {tab === "connections" ? (
              <ConnectionsTable deviceId={deviceId} refreshKey={refreshKey} />
            ) : (
              <TelemetryRecoveryTable deviceId={deviceId} onOpenAudit={openAudit} refreshKey={refreshKey} />
            )}
          </>
        )}
      </Box>
    </ServiceNavigationBar>
  );
};

export default DeviceAudits;
